module.exports = __webpack_public_path__ + "assets/tile-gage.png";